exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.el-scrollbar .el-scrollbar__wrap {\n  overflow-x: hidden;\n}", "", {"version":3,"sources":["F:/workSpace/eclipse/branch/mcFroutendTemp/src/components/common/trees/transfer_single_tree.vue"],"names":[],"mappings":";AAAA;EACE,mBAAmB;CACpB","file":"transfer_single_tree.vue","sourcesContent":[".el-scrollbar .el-scrollbar__wrap {\n  overflow-x: hidden;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":true,"importLoaders":2}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1940c942","scoped":false,"hasInlineConfig":false}!./node_modules/px2rem-loader?{"remUnit":54}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/trees/transfer_single_tree.vue
// module id = uEAt
// module chunks = 1